module.exports = __webpack_public_path__ + "static/media/13.c324e1f7.jpg";